import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {SearchService} from '../../../services/search.service';
import {PatientGlobalSearchModel} from '../../../models/search/patient-global-search.model';
import {TdoSearchEvent} from '../../../tdo-controls/common/tdo-search/models/TdoSearchEvent';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {Globals} from '../../../globals';
import {MessagingService} from '../../../services/messaging.service';

@Component({
  selector: 'app-tdo-global-search',
  templateUrl: './tdo-global-search.component.html',
  styleUrls: ['./tdo-global-search.component.scss']
})
export class TdoGlobalSearchComponent implements OnInit {
  @Output() clickedOutside = new EventEmitter<void>();

  patients: PatientGlobalSearchModel[] = [];

  constructor(private searchService: SearchService,
              private globals: Globals,
              private messagingService: MessagingService) { }

  ngOnInit(): void {
  }

  onClickOutside() {
    this.clickedOutside.emit();
  }

  onSearchChange(event: TdoSearchEvent) {
    this.searchService.globalSearch(event.value).subscribe((res) => {
      this.patients = res.patients;
    });
  }

  loadPatient(patient: PatientGlobalSearchModel) {
    //this.globals.currentPatientId = patient.patient.PatientId;
    this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
      PatientID: patient.patient.PatientId,
      // PatientName: user.PatientName,
      clearCurrentQuery: false
    });
    this.clickedOutside.emit();
  }
}
